/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DnspDeviceOptOutStatusResponse
 */
export interface DnspDeviceOptOutStatusResponse {
    /**
     *
     * @type {string}
     * @memberof DnspDeviceOptOutStatusResponse
     */
    deviceId?: string;
    /**
     * Eg ChargePoint, Wave
     * @type {string}
     * @memberof DnspDeviceOptOutStatusResponse
     */
    deviceType?: string;
    /**
     * List of DerEventIds the device has opted out of (limited to most recent 100 descending)
     * @type {Array<string>}
     * @memberof DnspDeviceOptOutStatusResponse
     */
    optedOutOfDerEventIds?: Array<string>;
    /**
     * True if this device is online and connected to the Illuminate system
     * @type {boolean}
     * @memberof DnspDeviceOptOutStatusResponse
     */
    isOnline?: boolean;
    /**
     * Device status, eg Available/Preparing/Charging/SuspendedEV/Faulted/Unavailable
     * @type {string}
     * @memberof DnspDeviceOptOutStatusResponse
     */
    status?: string;
}

/**
 * Check if a given object implements the DnspDeviceOptOutStatusResponse interface.
 */
export function instanceOfDnspDeviceOptOutStatusResponse(
    value: object,
): value is DnspDeviceOptOutStatusResponse {
    return true;
}

export function DnspDeviceOptOutStatusResponseFromJSON(
    json: any,
): DnspDeviceOptOutStatusResponse {
    return DnspDeviceOptOutStatusResponseFromJSONTyped(json, false);
}

export function DnspDeviceOptOutStatusResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspDeviceOptOutStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        optedOutOfDerEventIds:
            json["optedOutOfDerEventIds"] == null
                ? undefined
                : json["optedOutOfDerEventIds"],
        isOnline: json["isOnline"] == null ? undefined : json["isOnline"],
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function DnspDeviceOptOutStatusResponseToJSON(
    value?: DnspDeviceOptOutStatusResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceId: value["deviceId"],
        deviceType: value["deviceType"],
        optedOutOfDerEventIds: value["optedOutOfDerEventIds"],
        isOnline: value["isOnline"],
        status: value["status"],
    };
}
